import React, { Component } from 'react'
import classNames from 'classnames'
import Bubble from './Bubble'

class Tooltip extends Component {

  constructor (props) {
    super(props)
    this.state = {hidden: true}
  }

  render () {
    const options = this.props.options ? this.props.options : null

    var classes = classNames({
      'hidden': this.props.hidden
    })

    classes = this.props.classes + ' ' + classes

    return (
      <Bubble className={classes} style={this.props.arrow}>
        {this.props.children}
      </Bubble>
    )
  }
}

export default Tooltip
